module.exports = __webpack_public_path__ + "media/images/day-or-night-b7a0f66f0e94926e57d5eb77cfadea8d.svg";